module.exports = __webpack_public_path__ + "static/media/cs-1.f2142ca8.jpg";